<template>
    <div class="apple-login-wrap">
        <!-- 苹果官方渲染按钮容器 -->
        <div :key="theme" id="appleid-signin" class="apple-btn" :data-color="theme == 'dark' ? 'black' : 'white'"
            data-type="sign-in" data-logo-size="large" data-mode="center-align" data-border="true"></div>
    </div>
</template>

<script>
export default {
    name: "AppleLoginBtn",
    props: {
        clientId: {
            type: String,
            required: true
        },
        redirectUri: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            appleSDKLoaded: false
        };
    },

    computed: {
        theme: function () {
            return this.$store.state.theme
        }
    },

    mounted() {
        this.loadAppleSDK();
    },
    methods: {

        getAppleDataFromToken(token) {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            return JSON.parse(jsonPayload);
        },
        // 动态加载苹果官方JS
        loadAppleSDK() {
            if (window.AppleID) {
                this.initAppleAuth();
                return;
            }
            const script = document.createElement("script");
            script.src = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
            script.onload = () => {
                this.appleSDKLoaded = true;
                this.initAppleAuth();
            };
            document.head.appendChild(script);
        },
        // 初始化Apple授权
        initAppleAuth() {
            const state = Math.random().toString(36).slice(2);
            window.AppleID.auth.init({
                clientId: this.clientId,
                scope: "name email",
                redirectURI: this.redirectUri,
                usePopup: true, // PC弹窗，不跳转页面
                state: state
            });

            const that = this

            // 登录成功监听
            document.addEventListener("AppleIDSignInOnSuccess", async (e) => {
                // 传给父组件
                let appleUserData = that.getAppleDataFromToken(e.detail.authorization.id_token);
                if (e.detail.user) {
                    appleUserData = { ...appleUserData, ...e.detfail.user }
                }
                that.$emit("apple-login", { authorization: e.detail.authorization, userData: appleUserData });
            });

            // 登录失败监听
            document.addEventListener("AppleIDSignInOnFailure", (e) => {
                that.$emit("apple-error", e.detail.error);
            });
        }
    }
};
</script>

<style scoped>
.apple-btn {
    width: 280px;
    height: 42px;
    cursor: pointer;
}

.apple-login-wrap {
    height: 100px;
}
</style>